export function validateIpAddress(ip: string): string | null {
  if (!ip || ip.trim() === '') return 'IP address is required';

  const ipv4Regex = /^(\d{1,3}\.){3}\d{1,3}$/;
  const ipv6Regex = /^([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$/;

  if (!ipv4Regex.test(ip) && !ipv6Regex.test(ip)) {
    return 'Invalid IP address format';
  }

  if (ipv4Regex.test(ip)) {
    const octets = ip.split('.').map(Number);
    if (octets.some((octet) => octet > 255)) {
      return 'Invalid IPv4 address (octets must be 0-255)';
    }
  }

  return null;
}

export function validateDomain(domain: string): string | null {
  if (!domain) return 'Domain is required';
  const domainRegex = /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i;
  return domainRegex.test(domain) ? null : 'Invalid domain format';
}

export function validateAsn(asn: string): string | null {
  if (!asn) return 'ASN is required';
  const asnRegex = /^(AS)?(\d+)$/i;
  return asnRegex.test(asn) ? null : 'Invalid ASN format (e.g., AS12345 or 12345)';
}

export function parseAsn(asn: string): number | null {
  const asnRegex = /^(AS)?(\d+)$/i;
  const match = asn.match(asnRegex);
  if (!match) return null;
  return parseInt(match[2], 10);
}

export function validateIsp(isp: string): string | null {
  if (!isp || isp.length < 2) return 'ISP name must be at least 2 characters';
  return null;
}
